import { useEffect, useState } from "react";

let hasTriggeredCallBack = false;
const useCountdown = ({ startDate, reloadNewComp }) => {
    const countDownDate = new Date(startDate).getTime();

    const [countDown, setCountDown] = useState(
        countDownDate - new Date().getTime()
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown(countDownDate - new Date().getTime());

            if (countDownDate <= Date.now()) {
                if (!hasTriggeredCallBack) {
                    hasTriggeredCallBack = true;
                    reloadNewComp();
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [countDownDate, reloadNewComp]);

    return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
    // calculate time left
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
        (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

    return [days, hours, minutes, seconds];
};

export { useCountdown };